import { getContext, setContext } from 'svelte';
import type { ImageContext } from './types';

export const imageContextKey = Symbol('athena-image-context');

export const getImageContext = () => getContext<ImageContext | undefined>(imageContextKey);

export const getResizedImage = (imageWidth: number, imageBaseUrl: string) =>
  getImageContext()?.imageResizingUrlProvider?.(imageWidth, imageBaseUrl) ?? imageBaseUrl;

export const setImageResizingUrlProvider = (
  provider: (imageWidth: number, imageBaseUrl: string) => string,
) => {
  let context = getImageContext();
  if (!context) {
    context = {};
    setContext(imageContextKey, context);
  }
  context.imageResizingUrlProvider = provider;
};

export const setImageSizeParser = (
  provider: (src: string) => { width: number; height: number } | undefined,
) => {
  let context = getImageContext();
  if (!context) {
    context = {};
    setContext(imageContextKey, context);
  }
  context.imageSizeParser = provider;
};

export const getOptimizedImageUrl = (
  imageBaseUrl: string,
  imageContext: ImageContext | undefined,
) => imageContext?.imageOptimizationUrlProvider?.(imageBaseUrl) ?? imageBaseUrl;

export const setImageOptimizationUrlProvider = (provider: (imageBaseUrl: string) => string) => {
  let context = getImageContext();
  if (!context) {
    context = {};
    setContext(imageContextKey, context);
  }
  context.imageOptimizationUrlProvider = provider;
};
